import { render, staticRenderFns } from "./MailComposer.vue?vue&type=template&id=6b90e504"
import script from "./MailComposer.vue?vue&type=script&lang=js"
export * from "./MailComposer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports